export default (params) => ({
  trigger: {
    name: 'options_row.show_accessory_products',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      is_fallback: {
        type: 'boolean',
      },
      sub_feature: {
        enum: [
          'employee_atc_page',
          'employee_ato_page',
          'customer_atc_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'show_options_row_accessory_items',
    },
    nonInt: true,
  },
});
